import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ComparisonSection } from './components/ComparisonSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-paper font-sans text-ink" data-id="element-0" data-mp="28tmifcuwat1z">
      <Hero data-id="element-1" data-mp="28s30zixi6bym" />
      <main data-id="element-2" data-mp="23vkvggucm9l8">
        <ProblemSection data-id="element-3" data-mp="23vul23bheeqe" />
        <VolumesSection data-id="element-4" data-mp="23ujlygszdv5m" />
        <BonusesSection data-id="element-5" data-mp="23t8i6gzjcnei" />
        <OfferSection data-id="element-6" data-mp="3ijxsv0nzqion" />
        <GuaranteeSection data-id="element-7" data-mp="3ikqyfyb7r257" />
        <TestimonialsSection data-id="element-8" data-mp="3ijfw82xf22g7" />
        <ComparisonSection data-id="element-9" data-mp="3ii4r9zs8ioni" />
        <FaqSection data-id="element-10" data-mp="3ml12v6jcxkhy" />
        <FinalCtaSection data-id="element-11" data-mp="3mkhou0wtvg97" />
      </main>
      <Footer data-id="element-12" data-mp="3mjgczu7zmpqf" />
      <StickyCta data-id="element-13" data-mp="3rc9dg5wfbbwp" />
    </div>;
}